import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import SocialMediaIcon from '../../SocialMediaIcon'
import Img from '../../Img'
import { useAnalytics } from '../../../../common/analytics'

const AuthorInfo = ({ author }) => {
  const { track } = useAnalytics()

  const handleSocialIconClick = useCallback(
    (href, name) => {
      const data = {
        nav_link_section: 'Page',
        click_type: 'Social Media Click',
        click_id: name,
        click_url: href,
        click_text: `FDR-Web | ${name}`,
        track_event: 'link_click',
      }
      track(data)
    },
    [track]
  )

  return (
    <div className="my-10 px-2 md:block md:gap-5 md:text-left lg:px-0">
      <div className="flex md:gap-5">
        <div className="mr-5 md:mx-0">
          <Img
            src={author.avatar}
            alt="AuthorImage"
            className="h-16 w-16 overflow-hidden rounded-full"
          />
        </div>
        <div className="md:mt-0">
          <div>
            <a
              href={`/author/${author.slug}/`}
              className="cursor-pointer text-ms font-bold text-gray-510 hover:text-blue-700"
            >
              {author.fullName}
            </a>
            {author.jobTitle && (
              <span className="text-xs font-normal text-gray-245">
                {` / ${author.jobTitle}`}
              </span>
            )}
            <div className="mt-2 flex">
              {author.webPage && (
                <SocialMediaIcon
                  id="_webPage"
                  type="webPage"
                  url={author.webPage}
                  onClick={() =>
                    handleSocialIconClick(author.webPage, 'WebPage')
                  }
                />
              )}
              {author.facebook && (
                <SocialMediaIcon
                  type="facebook"
                  url={author.facebook}
                  onClick={() =>
                    handleSocialIconClick(author.facebook, 'Facebook')
                  }
                />
              )}
              {author.twitter && (
                <SocialMediaIcon
                  type="twitter"
                  url={`https://twitter.com/${author.twitter}/`}
                  onClick={() =>
                    handleSocialIconClick(
                      `https://twitter.com/${author.twitter}/`,
                      'Twitter'
                    )
                  }
                />
              )}
              {author.linkedIn && (
                <SocialMediaIcon
                  type="linkedin"
                  url={author.linkedIn}
                  onClick={() =>
                    handleSocialIconClick(author.linkedIn, 'LinkedIn')
                  }
                />
              )}
            </div>
          </div>
          <p className="hidden md:block">{author.description}</p>
        </div>
      </div>
      <p className="mt-2 block md:hidden">{author.description}</p>
    </div>
  )
}

AuthorInfo.propTypes = {
  author: PropTypes.object.isRequired,
}

export default AuthorInfo
